// @ts-nocheck

import { downloadRequestWithToken, fetchRequest, initialFetchListParams } from './index';
export const addDriver = async driver => {
  const added = await fetchRequest.post('/driver', driver);
  if (added) return added;
  throw new Error('Не удалось создать водителя');
};
export const updateDriver = async driver => {
  const updated = await fetchRequest.put('/driver', driver);
  if (updated) return updated;
  throw new Error('Не удалось обновить водителя');
};
export const fetchDrivers = async (params = initialFetchListParams) => await fetchRequest.get('/driver', {
  ...initialFetchListParams,
  ...params
});
export const fetchDriver = async (id, params = {}) => {
  const driver = await fetchRequest.get(`/driver/${id}`, params);
  if (driver) return driver;
  throw new Error('Не удалось загрузить водителя');
};
export const deleteDriver = async id => {
  const deleted = await fetchRequest.delete(`/driver/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить водителя');
};
export const uploadPhoto = async (driverId, photo) => {
  const added = await fetchRequest.post(`/driver/${driverId}/photo`, {
    driverId,
    photo
  });
  if (added) return added;
  throw new Error('Не удалось добавить фото водителя');
};
export const printTrips = async params => {
  const printed = await downloadRequestWithToken('/driver/trips/print', {
    ...params
  });
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};
export const printDrivingRatings = async params => {
  const printed = await downloadRequestWithToken('/driver/drivingRatings/print', {
    ...params
  });
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};
export const printDriverRegister = async () => {
  const printed = await downloadRequestWithToken('/driver/report/print');
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};
export const printDriverStats = async driverId => {
  const printed = await downloadRequestWithToken(`/driver/printDriverStats/${driverId}`);
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};
export const printTestsHistory = async driverId => {
  const printed = await downloadRequestWithToken(`/driver/${driverId}/testsHistory/print`);
  if (printed) return printed;
  throw new Error('Не удалось распечатать отчет');
};
export const driversWithUsers = async () => {
  const driver = await fetchRequest.get(`/driver/driversWithUsers`);
  if (driver) return driver;
  throw new Error('Не удалось загрузить водителей');
};
export default {
  addDriver,
  updateDriver,
  fetchDrivers,
  deleteDriver,
  fetchDriver,
  uploadPhoto,
  printTrips,
  printDrivingRatings,
  printDriverRegister,
  driversWithUsers,
  printDriverStats,
  printTestsHistory
};
